/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=c98bafdc&scoped=true&"
import script from "./contract.vue?vue&type=script&lang=js&"
export * from "./contract.vue?vue&type=script&lang=js&"
import style0 from "./contract.vue?vue&type=style&index=0&id=c98bafdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98bafdc",
  null
  
)

export default component.exports